import { TabContainer } from "../components/tab-container.js";
import { Modal } from "../components/modal.js";

export class RecourcesHcp {
    constructor(parameters) {
        var t = this;

        // master tab container
        new TabContainer(
            document.querySelector(".tab-container"),
            TabContainer.wipeMode.fixedSpeed,
            500, // mobile speed
            500); // desktop speed

        function loadWistiaJS() {
            // load Wistia javascript for videos           
            var s = document.createElement("script");
            s.src = "https://fast.wistia.com/embed/medias/4iw7sw1hf2.jsonp";
            s.async = true;
            document.body.appendChild(s);

            var c = document.createElement("script");
            c.src = "https://fast.wistia.com/assets/external/E-v1.js";
            c.async = true;
            document.body.appendChild(c);
        }

        // content in tab 1 launches a modal 
        var videoLink = document.querySelector('#downloadables a[data-video-id]'),
            diffDiagnosisTemplate = `<section class="modal-template">
 <div class="video-wrap">
<div class="video"> 
        <div class="wistia_embed wistia_async_4iw7sw1hf2"><!-- diagnostic pathway --></div>
</div>
</section>`;

        videoLink.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            var videoId = this.getAttribute('data-video-id');

            Modal.show(
                diffDiagnosisTemplate,
                'video-modal',
                Modal.presentationTypes.fade,
                Modal.presentationTypes.fade,
                false,
                {
                    preShow: function () {
                        //let modal = this;
                        loadWistiaJS();
                    },
                    postShow: function () {
                        let modal = this;
                        window._wq = window._wq || [];
                        // start playing current video
                        _wq.push({
                            id: videoId, onReady: function (video) {
                                video.play();
                            }
                        }); 
                    }
                },
                event
            );
        });

        // contents in tab 2 launches a modal        
        var caseStudies = document.querySelectorAll('#triggering-conditions a[data-video-label]'),
            templateB = `<section class="modal-template">
    <div class="video-navigation">
        <ul>
            <li id="video-link-postpartum" class="active">
                <a href="#" data-video-label="postpartum" data-video-id="u4d0wlbagp"><img src="/-/media/Images/Alexion/AhusSource2_com/Physician/images/diagnosing-ahus/ahussourcehcpiconpostpartum128lg2x.png" alt="Pregnancy/Postpartum" />
                    Pregnancy/<br>Postpartum</a>
                </li>
                <li id="video-link-hypertension">
                    <a href="#" data-video-label="hypertension" data-video-label="hypertension" data-video-id="ccdnhg35bk"><img src="/-/media/Images/Alexion/AhusSource2_com/Physician/images/diagnosing-ahus/ahussourcehcpiconhypertension128lg2x.png" alt="Malignant Hypertension" />
                    Malignant Hypertension</a>
                </li>
                <li id="video-link-lupus">
                    <a href="#" data-video-label="lupus" data-video-id="eyceea9alj"><img src="/-/media/Images/Alexion/AhusSource2_com/Physician/images/diagnosing-ahus/ahussourcehcpiconlupus128lg2x.png" alt="Systemic Lupus Erythematosus" />
                    Systemic&nbsp;Lupus Erythematosus</a>
                </li>
                <li id="video-link-transplantation">
                    <a href="#" data-video-label="transplantation" data-video-label="transplantation" data-video-id="lkubndgccr"><img src="/-/media/Images/Alexion/AhusSource2_com/Physician/images/diagnosing-ahus/ahussourcehcpicontransplantation128lg2x.png" alt="Organ Transplantation" />
                    Organ Transplantation</a>
                </li>
            </ul>
        </div>

        <div class="video-wrap">
            <div class="video">
                <div class="wistia_embed wistia_async_u4d0wlbagp"><!--pregnancy--></div>
                <div class="wistia_embed wistia_async_ccdnhg35bk"><!--hypertension--></div>
                <div class="wistia_embed wistia_async_eyceea9alj"><!--lupus--></div>
                <div class="wistia_embed wistia_async_lkubndgccr"><!--transplant--></div>
            </div>

            <div id="video-postpartum" class="video-content active">
                <div class="flex-row">
                    <div>
                        <p>Hear how your peers recognize persistent TMA and navigate the differential diagnosis of atypical-HUS in a pregnancy/postpartum setting.</p>

                        <p>Learn more about how atypical-HUS is diagnosed in this scenario by downloading and reviewing a case study.</p>

                    <p class="footnote">These are some triggers seen in atypical-HUS patients. Additional triggers may exist. See the <a href="/physician/diagnosing-ahus#triggers">Diagnosing aHUS page</a> for a more comprehensive list.</p>
                    </div>
                    <div> 
                        <a href="/Content/pdfs/Physician/Identifying-aHUS-Pregnancy-Postpartum" class="cta primary download internal-link" target="_blank">DOWNLOAD PDF</a>
                    </div>
                </div>
            </div>

            <div id="video-hypertension" class="video-content">
                <div class="flex-row">
                    <div>
                        <p>Hear how your peers work with a team of specialists to recognize persistent TMA and organ damage in the differential diagnosis of atypical-HUS in patients with malignant hypertension. </p>

                        <p>Learn more about how atypical-HUS is diagnosed in this scenario by downloading and reviewing a case study.</p>

                    <p class="footnote">These are some triggers seen in atypical-HUS patients. Additional triggers may exist. See the <a href="/physician/diagnosing-ahus#triggers">Diagnosing aHUS page</a> for a more comprehensive list.</p>
                    </div>
                    <div>
                        <a href="/Content/pdfs/Physician/Identifying-aHUS-Malignant-or-Severe-Hypertension" class="cta primary download internal-link" target="_blank">DOWNLOAD PDF</a>
                    </div>
                </div>

            </div>

            <div id="video-lupus" class="video-content">
               <div class="flex-row">
                <div>
                    <p>Hear how your peers confirm TMA and assess renal function and other organ damage to navigate the differential diagnosis of atypical-HUS in patients with systemic lupus erythematosus.</p>
                    <p>Learn more about how atypical-HUS is diagnosed in this scenario by downloading and reviewing a case study.</p>

                    <p class="footnote">These are some triggers seen in atypical-HUS patients. Additional triggers may exist. See the <a href="/physician/diagnosing-ahus#triggers">Diagnosing aHUS page</a> for a more comprehensive list.</p>
                </div>
                <div>
                    <a href="/Content/pdfs/Physician/Identifying-aHUS-Systemic-Lupus-Erythematosus" class="cta primary download internal-link" target="_blank">DOWNLOAD PDF</a>
                </div>
            </div>
        </div>

        <div id="video-transplantation" class="video-content">
            <div class="flex-row">
                <div>
                 <p>Hear how your peers confirm complement-mediated TMA and navigate the differential diagnosis of atypical-HUS in a transplant setting. </p>

                 <p>Learn more about how atypical-HUS is diagnosed in this scenario by downloading and reviewing a case study.</p>

                 <p class="footnote">These are some triggers seen in atypical-HUS patients. Additional triggers may exist. See the <a href="/physician/diagnosing-ahus#triggers">Diagnosing aHUS page</a> for a more comprehensive list.</p>
             </div>
             <div><a href="/Content/pdfs/Physician/Identifying-aHUS-Transplant" class="cta primary download internal-link" target="_blank">DOWNLOAD PDF</a></div>
         </div>
     </div>
 </div>
</section>`;
        // simple tab switcher inside modal
        function tabSwitcher(activeId, videoId) {
            var videoTabLinks = document.querySelectorAll('.video-navigation ul li'),
                videoWrapDivs = document.querySelectorAll('.video-wrap div'),
                newVideoId = videoId;

            for (var t = 0; t < videoTabLinks.length; t++) {
                videoTabLinks[t].classList.remove('active');
            }
            for (var w = 0; w < videoWrapDivs.length; w++) {
                videoWrapDivs[w].classList.remove('active');
            }
            document.getElementById('video-link-' + activeId).classList.add('active');
            document.getElementById('video-' + activeId).classList.add('active');

            window._wq = window._wq || [];
            // hide all videos
            var wistiaVideos = document.querySelectorAll('.wistia_embed');
            for (var v = 0; v < wistiaVideos.length; v++) {
                let wistiaVideo = wistiaVideos[v];
                wistiaVideo.style.display = 'none';
            }
            // show current video
            document.querySelector('.wistia_embed.wistia_async_' + newVideoId).style.display = 'block';
            // pause all videos and move time to zero
            _wq.push({
                id: "_all", onReady: function (video) {
                    video.pause();
                    video.time(0);
                }
            });

            // start playing current video
            _wq.push({
                id: newVideoId, onReady: function (video) {
                    video.play();
                }
            }); 

        }

        for (var i = 0; i < caseStudies.length; i++) {
            let caseStudy = caseStudies[i];

            caseStudy.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                let caseStudyTabId = this.getAttribute('data-video-label'),
                    videoId = this.getAttribute('data-video-id');

                Modal.show(
                    templateB,
                    'case-study-videos',
                    Modal.presentationTypes.fade,
                    Modal.presentationTypes.fade,
                    false,
                    {
                        preShow: function () {
                            //let modal = this;
                            //loadBrightcoveJS();
                            loadWistiaJS();
                        },
                        postShow: function () {
                            let modal = this;

                            tabSwitcher(caseStudyTabId, videoId);

                            let videoTabLinks = document.querySelectorAll('.video-navigation ul li');

                            for (var v = 0; v < videoTabLinks.length; v++) {
                                let videoTabLink = videoTabLinks[v];

                                videoTabLink.addEventListener('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    var videoTabId = this.querySelector('a').getAttribute('data-video-label');
                                    var videoId = this.querySelector('a').getAttribute('data-video-id');
                                    tabSwitcher(videoTabId, videoId);

                                });

                            }

                            var triggerLinks = modal.container.querySelectorAll('p.footnote a'),
                                loc = document.getElementById('anchor-tma-triggers');

                            for (var i = 0; i < triggerLinks.length; i++) {
                                let triggerLink = triggerLinks[i];

                                triggerLink.addEventListener('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    modal.close(false, Modal.presentationTypes.fade);
                                    window.location = '/physician/diagnosing-ahus#triggers';
                                });
                            };
                        }
                    },
                    event
                );

            })
        }

    }
}